import React from "react";
import Modal from "@mui/joy/Modal";
import ModalDialog from "@mui/joy/ModalDialog";
import DialogTitle from "@mui/joy/DialogTitle";
import DialogContent from "@mui/joy/DialogContent";
import DialogActions from "@mui/joy/DialogActions";
import Button from "@mui/joy/Button";
import Alert from "@mui/joy/Alert";
import Typography from "@mui/joy/Typography";
import IconButton from "@mui/joy/IconButton";
import WarningAmber from "@mui/icons-material/WarningAmber";
import CloseRounded from "@mui/icons-material/CloseRounded";

export default function RoleConfirmationPopup({ open = false, onClose = () => {}, onConfirm = () => {} }) {
    return (
        <Modal open={open} onClose={onClose} disablePortal disableScrollLock={true}>
            <ModalDialog variant="soft" sx={{ width: 580, maxWidth: "90vw" }}>
                <DialogTitle sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <WarningAmber color="warning" />
                    Pending Role
                    <IconButton
                        variant="plain"
                        size="sm"
                        color="neutral"
                        onClick={onClose}
                        sx={{ marginLeft: "auto" }}
                        aria-label="close"
                    >
                        <CloseRounded />
                    </IconButton>
                </DialogTitle>

                <DialogContent>
                    <Alert color="warning" variant="soft" >
                        <Typography level="body-md">
                            Role is not confirmed. Please confirm the role before proceeding further!
                        </Typography>
                    </Alert>
                </DialogContent>

                <DialogActions sx={{ mt: 1, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button variant="solid" color="primary" onClick={onConfirm}>
                        Confirm Role
                    </Button>
                    <Button variant="outlined" color="neutral" onClick={onClose}>
                        Ignore
                    </Button>
                </DialogActions>
            </ModalDialog>
        </Modal>
    );
}